
import { City, CityPoint } from "@/models/City";
import { MapOptions } from "@/models/Map";
import { cloneDeep, forIn, isEqual, toArray } from "lodash";
import Map from "../../../Base/Map.vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { MAP_STATUS, QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import DeleteBox from "../../../Base/DeleteBox.vue";
import DeleteBoxEditable from "../../../Base/DeleteBoxEditable.vue";
import AlertBoxEditable from "../../../Base/AlertBoxEditable.vue";
import { ChallengeData } from "@/models/Base/ChallengeData";
import ChallengeBox from "../../../Base/ChallengeBox.vue";
import { Game } from "@/models/Game";
import DateHelper from "@/utils/DateHelper";
import { Validations } from "vuelidate-property-decorators";
import { UserData } from "@/models/User";
import ImageSelector from "@/components/Base/ImageSelector.vue";
import {
  required,
  minLength,
  maxLength,
  minValue,
} from "vuelidate/lib/validators";

@Component({
  components: {
    Map,
    DeleteBox,
    AlertBoxEditable,
    ChallengeBox,
    ImageSelector,
    DeleteBoxEditable,
  },
})
class PoiGeneral extends Vue {
  @Prop({ default: null }) readonly mapPoi!: QuestMapPoi;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  mapPoiClone = {} as QuestMapPoi;
  getSelectMapStatus = "";
  selectedCity = "";
  poiType = "person";
  lat = 0;
  lng = 0;
  deleteMessage = "";
  show3DSelectorBool = false;
  warnMessage = false;
  is3D = false;

  get cityNotes(): string {
    if (
      this.mapPoi.loc.loc_uid !== undefined &&
      this.mapPoi.loc.loc_uid !== ""
    ) {
      if (
        this.cityData.locations[this.mapPoi.loc.loc_uid].notes === undefined
      ) {
        return "";
      } else {
        return this.cityData.locations[this.mapPoi.loc.loc_uid].notes || "";
      }
    }
    return "";
  }

  get get3DPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/model/poi/"
    );
  }

  get isStartZone(): boolean {
    if (this.mapPoi.title.en === "START_ZONE") {
      return true;
    }
    return false;
  }

  get getUserData(): UserData {
    return this.$store.state.authenication.userData;
  }

  get generateLink(): string {
    return (
      process.env.VUE_APP_DATABASEURL +
      "/map_poi/" +
      this.gameData.key +
      "/" +
      this.mapPoi.key
    );
  }

  get getChallengeData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    try {
      challengeData.text = this.mapPoi.desc?.en || "";
      challengeData.image = this.mapPoi.image || "";
      challengeData.audio = { en: "" };
      return challengeData;
    } catch (error) {
      console.log(error);
      return challengeData;
    }
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/poi/"
    );
  }

  get getCurrentMapLocation(): MapOptions {
    var val = this.cityData.locations[this.mapPoi.loc.loc_uid];
    if (val !== undefined) {
      this.lat = val.lat_long.latitude;
      this.lng = val.lat_long.longitude;
      var locationMarker: MapOptions = {
        position: {
          lat: this.lat,
          lng: this.lng,
        },
        title: this.mapPoi.title.en,
        draggable: true,
        clickable: true,
        slug: val.slug,
        radius: this.mapPoi.loc.geo_rad_m,
        color: this.mapPoi.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
        zIndex: 10011,
        icon: DateHelper.getMapQuestImage(this.mapPoi),
      };
      return locationMarker;
    } else {
      this.lat = this.mapPoi.loc.override_ll.latitude;
      this.lng = this.mapPoi.loc.override_ll.longitude;
      var locationMarker2: MapOptions = {
        position: {
          lat: this.lat,
          lng: this.lng,
        },
        title: this.mapPoi.title.en,
        draggable: true,
        clickable: true,
        slug: this.mapPoi.title.en,
        radius: this.mapPoi.loc.geo_rad_m,
        color: this.mapPoi.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
        zIndex: 10011,
        icon: DateHelper.getMapQuestImage(this.mapPoi),
      };
      return locationMarker2;
    }
  }

  get getLocationsArray(): CityPoint[] {
    const arr: CityPoint[] = [];
    forIn(this.cityData.locations, (val: CityPoint) => {
      arr.push(val);
    });
    return arr;
  }

  get getLocationsMap(): MapOptions[] {
    var arr: MapOptions[] = [];
    try {
      forIn(this.cityData.locations, (val: CityPoint) => {
        var mapPoiExist = this.getMapPoiData.find(
          (x) => x.loc.loc_uid === val.slug
        );
        if (mapPoiExist === undefined && this.mapPoi.loc.loc_uid !== val.slug) {
          if (val.slug !== "centre_point") {
            var locationMarker: MapOptions = {
              position: {
                lat: val.lat_long.latitude,
                lng: val.lat_long.longitude,
              },
              title: val.name.en,
              slug: val.slug,
              draggable: false,
              clickable: true,
              zIndex: 100,
              icon: require("@/assets/images/map/city-gray.svg"),
            };

            arr.push(locationMarker);
          }
        }
      });
      this.getMapPoiData.forEach((val: QuestMapPoi) => {
        if (val.key !== this.mapPoi.key) {
          var cityData = this.getLocationsArray.find(
            (x: CityPoint) => val.loc.loc_uid === x.slug
          );
          var locationMarker2: MapOptions = {
            position: {
              lat:
                cityData !== undefined && cityData.lat_long !== undefined
                  ? cityData!.lat_long.latitude
                  : val.loc.override_ll.latitude,
              lng:
                cityData !== undefined && cityData.lat_long !== undefined
                  ? cityData!.lat_long.longitude
                  : val.loc.override_ll.longitude,
            },
            title: val.title.en,
            draggable: false,
            clickable: true,
            slug: val.key,
            radius: val.loc.geo_rad_m,
            color: val.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
            zIndex: 1001,
            icon: DateHelper.getGreyMapQuestImage(val),
          };
          arr.push(locationMarker2);
        }
      });
      arr.push(this.getCurrentMapLocation);
      return arr;
    } catch (error) {
      console.log(error);
      return arr;
    }
  }

  get getLocations(): any[] {
    const arr: any = [];
    forIn(this.cityData.locations, (val: CityPoint) => {
      if (this.mapPoi.loc.loc_uid === val.slug) {
        arr.push({ value: val.slug, text: val.name.en });
      } else {
        var mapPoiExist = this.getMapPoiData.find(
          (x) => x.loc.loc_uid === val.slug
        );
        if (mapPoiExist === undefined) {
          arr.push({ value: val.slug, text: val.name.en });
        }
      }
    });
    return arr;
  }

  get getMapStatus(): string[] {
    return MAP_STATUS;
  }

  get getPoiType(): string[] {
    return this.$store.state.mapPoiStore.poiTypes;
  }

  get getMapPoiData(): QuestMapPoi[] {
    return this.$store.state.mapPoiStore.questMapPoi;
  }

  get centerPoint(): any {
    return {
      latitude: this.lat,
      longitude: this.lng,
    };
  }

  created(): void {
    if (this.mapPoi.type !== undefined) {
      this.poiType = this.mapPoi.type;
    }
    this.getSelectMapStatus = this.mapPoi.mapStatus;
    this.selectedCity = this.mapPoi.loc.loc_uid;
    this.mapPoiClone = cloneDeep(this.mapPoi);
  }

  checkAmenitiesWarning(): void {
    if (this.poiType == "amenities") {
      this.$emit("changeAmentity", this.poiType);
      this.warnMessage = true;
    } else {
      this.warnMessage = false;
      this.$emit("changeAmentity", this.poiType);
    }
  }

  onValueChanged(): void {
    this.$v.$touch();
    this.checkAmenitiesWarning();
    if (!this.$v.$anyError) {
      this.mapPoi.type = this.poiType;
      if (!isEqual(this.mapPoi, this.mapPoiClone)) {
        this.showSavePanel = true;
      } else {
        this.showSavePanel = false;
      }
      this.$emit("updateTempObject", this.mapPoi);
    }
  }

  @Watch("isSavedOrDiscard")
  onisSaveOrDiscardChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }

  deleteItem(): void {
    var data = {
      gameUid: this.gameData.key,
      key: this.mapPoi.key,
    };
    this.$store.dispatch("mapPoiStore/deletePoi", data);
    this.$emit("closeDialog");
  }

  reinstatePOI(): void {
    var data = {
      parentUid: this.gameData.clone_parent,
      gameUid: this.gameData.key,
      key: this.mapPoi.key,
      mapPoi: this.mapPoi,
    };
    this.$store.dispatch("mapPoiStore/reinstatePOI", data);
    this.$emit("runErrorCheck");
    this.$emit("closeDialog");
  }

  close(): void {
    this.$bvModal.hide("modal-alert-delete-box");
  }

  mapData(place: any): void {
    this.lat = place.latitude;
    this.lng = place.longitude;
    this.selectedCity = "";
    this.mapPoi.loc.loc_uid = "";
    this.mapPoi.loc.override_ll.latitude = place.latitude;
    this.mapPoi.loc.override_ll.longitude = place.longitude;
    this.onValueChanged();
  }

  handleCloseButtonPress(): void {
    this.show3DSelectorBool = false;
  }

  changeLocation(slug: string): void {
    const location = this.getLocationsArray.find((x) => x.slug === slug);
    this.mapPoi.loc.loc_uid = slug;
    this.selectedCity = slug;
    if (location !== undefined) {
      this.lat = location.lat_long.latitude || 0;
      this.lng = location.lat_long.longitude || 0;
    }
    this.onValueChanged();
  }
  changeMapStatus(value: string): void {
    this.mapPoi.mapStatus = value;
    if (value === "inactive") {
      this.mapPoi.visible = true;
      this.mapPoi.active = false;
    }
    if (value === "active") {
      this.mapPoi.visible = true;
      this.mapPoi.active = true;
    }
    if (value === "hidden") {
      this.mapPoi.visible = false;
      this.mapPoi.active = true;
    }
    if (value === "hidden(inactive)") {
      this.mapPoi.visible = false;
      this.mapPoi.active = false;
    }
    this.onValueChanged();
  }
  openLocation(slug: string): void {
    const location = this.getLocationsArray.find((x) => x.slug === slug);
    this.mapPoi.loc.loc_uid = slug;
    this.selectedCity = slug;
    if (location !== undefined) {
      this.lat = location.lat_long.latitude || 0;
      this.lng = location.lat_long.longitude || 0;
    }
    this.onValueChanged();
  }

  openDeleteBox(): void {
    const deletedItems: string[] = [];
    this.deleteMessage = "";
    this.getMapPoiData
      .filter((x: QuestMapPoi) =>
        x.actionGoalRef?.filter((x: any) => x.id === this.mapPoi.key)
      )
      .forEach((y) => {
        y.actionGoalRef
          ?.filter((z: any) => z.id === this.mapPoi.key)
          .forEach((a) => {
            this.deleteMessage += a.helperPath + "\r\n";
            deletedItems.push(a.helperPath);
          });
      });
    if (deletedItems.length > 0) {
      this.$bvModal.show("team-modal-alert-edit");
    } else {
      this.$bvModal.show("team-modal-delete");
    }
  }

  show3DSelector(): void {
    this.show3DSelectorBool = true;
    this.is3D = true;
  }

  onDataChange(challenge: ChallengeData): void {
    if (this.mapPoi !== undefined) {
      this.mapPoi.desc = { en: challenge.text };
      this.mapPoi.image = challenge.image;
      this.onValueChanged();
    }
  }

  return3DPath(path: string): void {
    this.show3DSelectorBool = false;
    this.mapPoi.content3D = {
      fbxPaths: this.get3DPath + "" + path,
    };
    this.onValueChanged();
  }

  @Validations()
  validations = {
    mapPoi: {
      loc: {
        geo_rad_m: {
          required,
          minValue: minValue(10),
        },
      },
    },
  };
}

export default PoiGeneral;
